import * as React from 'react'

import { Box, Button, Section } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import TextInput from 'modules/core/components/Inputs/Text'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import i18n from 'modules/core/lib/i18n'

import type ShiftTemplate from 'modules/shift_management/store/api/models/ShiftTemplate'

interface Props {
  shiftTemplate: ShiftTemplate
}

function BasicInfo({ shiftTemplate }: Props) {
  const form = useLazyRef<Form>(
    () =>
      new Form(
        {
          name: shiftTemplate.attributes.name,
        },
        {
          name: 'string',
        }
      )
  ).current

  const { performAction: submit, running } = useAsyncAction(() => form.save(shiftTemplate))

  const title = i18n.t('shift_management.rotating_shifts.edit_title')

  const description = i18n.t('shift_management.rotating_shifts.edit_description')

  return (
    <Section illustration="document-edit" title={title} description={description}>
      <Box
        gap="s8"
        background="grey200"
        padding="s32"
        borderRadius={{
          all: 'abs008',
        }}
      >
        <TextInput
          field={form.get('name')}
          label={i18n.t('shift_management.rotating_shifts.edit_label_name')}
        />
        {form.get('name').isDirty && (
          <Box alignItems="flexEnd">
            <Button onClick={submit} disabled={running}>
              {i18n.t('shift_management.rotating_shifts.edit_button')}
            </Button>
          </Box>
        )}
      </Box>
    </Section>
  )
}

export default observer(BasicInfo)
